export default {
  // Dialog title
  title: "Save Canvas",

  // Form labels
  canvasName: "Canvas Name",
  canvasDescription: "Canvas Description",

  // Placeholders
  namePlaceholder: "Please enter canvas name (required)",
  descriptionPlaceholder: "Please describe the canvas",

  // Buttons
  cancel: "Cancel",
  confirm: "Confirm",

  // Validation rules
  nameRequired: "Canvas name is required",
};
